import apiReq from '../commontools/api.js'
export function GetGRReportUrl(corpid,checkno) {
	var url = apiReq.defaults.baseURL+'/ShowFile/GetGRReport/'+corpid+'/' + checkno ;
	return url;
}
export function GetYGReportUrl(corpid,checkno) {
	var url = apiReq.defaults.baseURL+'/ShowFile/GetYGReport/'+corpid+'/' + checkno ;
	return url;
}
export function GetCusReported(mobile) {
	var url = '/CusInfo/GetCusReported/' + mobile;
	return apiReq.get(url)
}

export function GetGRReportIsExists(corpid,checkno) {
	var url = '/ShowFile/GetGRReportIsExists/' +corpid+'/' + checkno ;
	return apiReq.get(url)
}

export function GetYGReportIsExists(corpid,checkno) {
	var url = '/ShowFile/GetYGReportIsExists/' +corpid+'/' + checkno ;
	return apiReq.get(url)
}



export default {
	GetYGReportUrl,
	GetGRReportUrl,
	GetCusReported,
	GetYGReportIsExists,
	GetGRReportIsExists
}
